export type LandingPagePayload = {
  id: number
  title?: string
  subtitle?: string
  picture?: File | null
  removePicture?: boolean
  showForm?: boolean
  showSections?: boolean
  sections?: Array<{
    id?: number | null
    title: string
    description: string
    image: File | null
  }>
  showTestimonials?: boolean
  testimonials?: Array<{
    id?: number | null
    clientName: string
    roleOrCompany: string
    comment: string
    rating: number
  }>
  mail?: string
  phone?: string
  tva?: string
  address?: string
  firstname?: string
  lastname?: string
  logo?: File | null
  removeLogo?: boolean
  color?: string
}

export function getLandingPage(landingPageId: number) {
  return {
    url: `/api/landing_pages/${landingPageId}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function upsertLandingPage(payload: LandingPagePayload) {
  const { id, picture, logo, sections, removePicture, removeLogo, ...textData } = payload

  const formData = new FormData()

  // Prepare JSON data object for all text fields
  const jsonData: any = {}

  if (textData.title !== undefined) jsonData.title = textData.title
  if (textData.subtitle !== undefined) jsonData.subtitle = textData.subtitle
  if (textData.showForm !== undefined) jsonData.showForm = textData.showForm
  if (textData.showSections !== undefined) jsonData.showSections = textData.showSections
  if (textData.showTestimonials !== undefined) jsonData.showTestimonials = textData.showTestimonials
  if (textData.mail !== undefined) jsonData.mail = textData.mail
  if (textData.phone !== undefined) jsonData.phone = textData.phone
  if (textData.tva !== undefined) jsonData.tva = textData.tva
  if (textData.address !== undefined) jsonData.address = textData.address
  if (textData.firstname !== undefined) jsonData.firstname = textData.firstname
  if (textData.lastname !== undefined) jsonData.lastname = textData.lastname
  if (textData.color !== undefined) jsonData.color = textData.color
  if (removePicture !== undefined) jsonData.removePicture = removePicture
  if (removeLogo !== undefined) jsonData.removeLogo = removeLogo

  // Add sections data (without images)
  if (sections) {
    jsonData.sections = sections.map((section) => ({
      id: section.id,
      title: section.title,
      description: section.description,
    }))
  }

  // Add testimonials
  if (textData.testimonials) {
    jsonData.testimonials = textData.testimonials
  }

  // Add JSON data as 'data' field
  formData.append('data', JSON.stringify(jsonData))

  // Add picture (hero image)
  if (picture) {
    formData.append('picture', picture)
  }

  // Add logo (company logo)
  if (logo) {
    formData.append('logo', logo)
  }

  // Add section images as sections[index][image]
  if (sections) {
    sections.forEach((section, index) => {
      if (section.image) {
        formData.append(`sections[${index}][image]`, section.image)
      }
    })
  }

  return {
    url: `/api/landing_pages/${id}/upsert`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
    body: formData,
  }
}

export type ContactFormPayload = {
  name: string
  email: string
  phone?: string
  message: string
}

export function sendContactForm(landingPageId: number, payload: ContactFormPayload) {
  return {
    url: `/api/landing_pages/${landingPageId}/mail`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}
